import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TextSeo } from '@shared/components/text-seo/models';
import { HandleHtmlLinksDirective } from '@shared/directives';

@Component({
  selector: 'app-text-seo',
  imports: [TranslatePipe, HandleHtmlLinksDirective],
  templateUrl: './text-seo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextSeoComponent {
  textSeo = input.required<TextSeo>();
  hasScroll = input(false);
  isOpen = signal(false);
}
